import { render, staticRenderFns } from "./MiddleCmp.vue?vue&type=template&id=28ee9f92&scoped=true&"
import script from "./MiddleCmp.vue?vue&type=script&lang=js&"
export * from "./MiddleCmp.vue?vue&type=script&lang=js&"
import style0 from "./MiddleCmp.vue?vue&type=style&index=0&id=28ee9f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee9f92",
  null
  
)

export default component.exports